import React from 'react';
import { ThemeProps } from 'styled-components';
import { Author } from '../../';
import colors from '../../../../helpers/colors';
import componentProps, { ComponentProps } from '../../../../helpers/componentProps';
import { applyComponentTheme, Theme } from '../../../../theme';
import Icon from '../../../Icon';
import {
  JobTitleSpan,
  StyledTestimonialCardDoubleMarks,
  TestimonialAuthorInfo,
  TestimonialIconBottom,
  TestimonialIconTop,
} from './styles';

export type TestimonialCardDoubleMarksProps = {
  icon: string;
  quote: string;
  screenReaderText: string;
  author?: Author;
  showAuthor?: boolean;
  themeColor: ({ theme }: ThemeProps<Theme>) => string;
} & ComponentProps;

const TestimonialCardDoubleMarks: React.FC<TestimonialCardDoubleMarksProps> = ({
  icon,
  quote,
  screenReaderText,
  author,
  showAuthor,
  themeColor,
  ...props
}) => (
  <StyledTestimonialCardDoubleMarks
    tabIndex={0}
    themeColor={themeColor}
    aria-label={screenReaderText}
    role="listitem"
    {...componentProps(props)}>
    <TestimonialIconTop>
      <Icon name={icon} size="medium" color={colors.neutral08} />
    </TestimonialIconTop>
    {quote}
    <TestimonialIconBottom>
      <Icon name={icon} size="medium" flipX flipY color={colors.neutral08} />
    </TestimonialIconBottom>

    {!!author && showAuthor && (
      <TestimonialAuthorInfo>
        {author.authorName}
        {author.authorName && author.authorJobTitle && ' - '}
        <JobTitleSpan>{author.authorJobTitle}</JobTitleSpan>
      </TestimonialAuthorInfo>
    )}
  </StyledTestimonialCardDoubleMarks>
);

export default applyComponentTheme(TestimonialCardDoubleMarks, 'TestimonialCard');
